import React, { useState } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';

import BasicDatePicker from './BasicDatePicker';
import { updateHolidays } from '../data/API';
import ProgressDialog from '../mui/progressdialog';

const Holidays = ({ holidays }) => {

  const [copiedData, setHolidays] = useState(holidays);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);


  const [isLoading, setIsLoading] = React.useState(false);


  const handleDelete = (holiday) => {
    setSelectedHoliday(holiday);
    setOpenDeleteDialog(true);
  };



  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleConfirmDelete = () => {
    setOpenDeleteDialog(false);
    const updatedHolidays = copiedData.filter((holiday) => holiday !== selectedHoliday);

    setHolidays(updatedHolidays);
  };

   const saveChanges=()=>{
    const filteredData = copiedData.filter(holiday => holiday.name !== '' && holiday.date !=='' && holiday.comment!=='' );

   // console.log(filteredData);

    setIsLoading(true);
    updateHolidays(filteredData,(err,data)=>{
      //console.log(data);
      setIsLoading(false);
      // var holidays2 = [...data];
      // setHolidays(holidays2);
    })

   }


  return (
    <div>
      <div >
      <ProgressDialog msg={"Loading Settings"} visible={isLoading} />
      
        <span style={{borderRadius:'10px', padding:10,backgroundColor:'white',position: 'absolute', right: '3%',top:"3%" }}>
          <Button style={{ marginInlineEnd: 10 }} variant="contained" color="primary"
            onClick={() => {
              const newHoliday = {
                'id': copiedData.length!=0 ?copiedData[copiedData.length-1].id +1:1,
                'name': "",
                'date': '',
                'comment': '',
                'created_at': null,
                'updated_at': null
              };
              const updatedHolidays = [...copiedData, newHoliday]; // Create a new array with the updated data
            
              setHolidays(updatedHolidays); // Set the state with the new array
            }}
          > Add New Holiday </Button>

          <Button onClick={saveChanges} variant="contained" color="success">Save Changes</Button>
        </span>

      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Comment</TableCell>

              <TableCell>Date</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {copiedData.map((holiday) => (
              <TableRow key={holiday.id}>
                <TableCell>{holiday.id}</TableCell>
                <TableCell><TextField
                  label="Name"
                  variant="outlined"
                  fullWidth
                  name="name"

                  defaultValue={holiday.name}
                  onChange={(e) => {
                    var index = copiedData.indexOf(holiday);
                    holiday.name = e.target.value;
                    copiedData[index] = holiday;

                    setHolidays(copiedData);

                  }}
                />

                </TableCell>
                <TableCell><TextField
                  label="Comment"
                  variant="outlined"
                  fullWidth
                  name="comment"

                  defaultValue={holiday.comment}
                  onChange={(e) => {
                    var index = copiedData.indexOf(holiday);
                    holiday.comment = e.target.value;
                    copiedData[index] = holiday;

                    setHolidays(copiedData);

                  }}
                />

                </TableCell>
                <BasicDatePicker label={"Holiday Date"} defaultValue={holiday.date} onChange={function (e) {
                  var index = copiedData.indexOf(holiday);
                  var date = e.format('M-D-YYYY')
                  holiday.date = date;
                  copiedData[index] = holiday;

                  setHolidays(copiedData);
                }} />
                <TableCell>

                  <Button onClick={() => handleDelete(holiday)} variant="contained" color="secondary">
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>



      {/* Delete Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Delete Holiday</DialogTitle>
        <DialogContent>
          Are you sure you want to delete {selectedHoliday && selectedHoliday.name}?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Holidays;
